/* GLiTCH "First Dibs" signup popup.
   Desktop: scratch -> email -> flavor -> SMS -> done.
   Phones:  scratch -> SMS -> email -> flavor -> done.
   Email -> Presale Waitlist (welcome flow). SMS -> Text Messaging list (SMS welcome flow). Klaviyo client APIs, no app. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gxp]');
  if (!root) return;
  var CFG = (window.GX && window.GX.cfg) || {};
  var REV = '2024-10-15';
  var KEY = { joined: 'gxp_joined', closed: 'gxp_closed_at', sms: 'gxp_sms', email: 'gxp_email' };
  var ls = { get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var d = root.dataset;
  var card = $('.gxp-card');
  var who = { email: '', phone: '' };
  var lastFocus = null;
  var design = window.Shopify && window.Shopify.designMode;
  var phone = window.matchMedia && matchMedia('(max-width: 719px)').matches;
  var mfirst = phone && d.mfirst === 'true' && !!d.smsList;
  if (mfirst) root.classList.add('is-mfirst');
  root.hidden = false;

  /* ---- step order ---- */
  var has = function (n) { return !!$('[data-gxp-step="' + n + '"]'); };
  var seq = (mfirst ? ['scratch', 'sms', 'email', 'flavor', 'done'] : ['scratch', 'email', 'flavor', 'sms', 'done']).filter(function (n) {
    if (n === 'sms' && !d.smsList) return false;
    if (n === 'flavor' && !$('[data-gxp-flavor]')) return false;
    return has(n);
  });
  var cur = seq[0];
  var go = function (name) {
    cur = name;
    $$('[data-gxp-step]').forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-gxp-step') === name); });
    var i = $('[data-gxp-step="' + name + '"] input'); if (i && root.classList.contains('is-open')) setTimeout(function () { i.focus({ preventScroll: true }); }, 80);
    if (name === 'scratch') initScratch();
  };
  var next = function () {
    var i = seq.indexOf(cur), n = seq[i + 1] || 'done';
    if (n === 'sms' && ls.get(KEY.sms)) n = seq[seq.indexOf('sms') + 1] || 'done';
    if (n === 'email' && who.email) n = seq[seq.indexOf('email') + 1] || 'done';
    go(n);
  };
  go(cur);

  /* ---- who should never see it ---- */
  var path = location.pathname.replace(/\/+$/, '') || '/';
  var skip = (d.skip || '').split(/\n|,/).map(function (p) { return p.trim().replace(/\/+$/, ''); }).filter(Boolean);
  var fromKlaviyo = /[?&]_kx=|utm_source=klaviyo|utm_medium=(email|sms)/i.test(location.search);
  if (fromKlaviyo) ls.set(KEY.joined, '1');
  var joined = ls.get(KEY.joined) || ls.get('glitch_presale_joined');
  var closedAt = parseInt(ls.get(KEY.closed) || '0', 10);
  var cooling = closedAt && (Date.now() - closedAt) < (parseInt(d.cooldown || '7', 10) * 864e5);
  var blockedPath = skip.some(function (p) { return p && (path === p || path.indexOf(p + '/') === 0); });

  /* ---- klaviyo ---- */
  var post = function (url, body) {
    return fetch('https://a.klaviyo.com/client/' + url + '/?company_id=' + encodeURIComponent(CFG.company), {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: REV }, body: JSON.stringify(body)
    }).then(function (r) {
      if (r.ok || r.status === 202) return true;
      return r.json().catch(function () { return {}; }).then(function (j) {
        var d0 = (j.errors && j.errors[0]) || {}; var e = new Error(d0.detail || ('klaviyo ' + r.status));
        e.field = (d0.source && d0.source.pointer || '').split('/').pop(); throw e;
      });
    });
  };
  var subscribe = function (attrs, listId, channel) {
    /* client API: consent comes from the list (email list = email consent, SMS list = SMS consent) */
    return post('subscriptions', { data: { type: 'subscription', attributes: { custom_source: 'GLiTCH First Dibs popup', profile: { data: { type: 'profile', attributes: attrs } } }, relationships: { list: { data: { type: 'list', id: listId } } } } });
  };
  var ident = function () { var a = {}; if (who.email) a.email = who.email; if (who.phone) a.phone_number = who.phone; return a; };
  var updateProfile = function (props) {
    var a = ident(); if (!a.email && !a.phone_number) return Promise.resolve(); a.properties = props;
    return post('profiles', { data: { type: 'profile', attributes: a } }).catch(function () {});
  };
  var track = function (name, props) { try { if (window.klaviyo && window.klaviyo.track) window.klaviyo.track(name, props || {}); } catch (e) {} };
  var markJoined = function () { ls.set(KEY.joined, '1'); root.classList.remove('has-teaser'); };

  /* ---- scratch-off ---- */
  var scratched = false, scratchReady = false;
  var reveal = function () {
    if (scratched) return; scratched = true;
    var box = $('[data-gxp-scratch]'); if (box) box.classList.add('is-done');
    var rv = $('[data-gxp-reveal]'), cl = $('[data-gxp-claim]');
    if (rv) rv.hidden = true; if (cl) { cl.hidden = false; setTimeout(function () { cl.focus({ preventScroll: true }); }, 50); }
    confetti(); track('Revealed GLiTCH Scratch Card');
  };
  var confetti = function () {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var c = document.createElement('div'); c.className = 'gxp-confetti';
    var cols = ['#C6F23E', '#FF3D8C', '#FFD60A', '#19C8D6', '#FFFDF5'];
    for (var i = 0; i < 28; i++) { var p = document.createElement('i'); p.style.left = (Math.random() * 100) + '%'; p.style.background = cols[i % cols.length]; p.style.animationDelay = (Math.random() * .35) + 's'; p.style.transform = 'rotate(' + (Math.random() * 180) + 'deg)'; c.appendChild(p); }
    card.appendChild(c); setTimeout(function () { c.remove(); }, 2000);
  };
  function initScratch() {
    if (scratchReady) return;
    var box = $('[data-gxp-scratch]'); if (!box) return;
    var cv = box.querySelector('canvas'); var r = box.getBoundingClientRect();
    if (!r.width) return; scratchReady = true;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = r.width * dpr; cv.height = r.height * dpr;
    var x = cv.getContext('2d'); x.scale(dpr, dpr);
    var g = x.createLinearGradient(0, 0, r.width, r.height);
    g.addColorStop(0, '#0A0A0A'); g.addColorStop(1, '#2a2a2a');
    x.fillStyle = g; x.fillRect(0, 0, r.width, r.height);
    x.fillStyle = 'rgba(198,242,62,.9)';
    x.font = "22px 'Bagel Fat One', system-ui, sans-serif"; x.textAlign = 'center';
    for (var yy = 26; yy < r.height + 20; yy += 34) for (var xx = (yy / 34 % 2) * 40; xx < r.width + 40; xx += 80) x.fillText('★', xx, yy);
    x.globalCompositeOperation = 'destination-out';
    var down = false, last = null, moves = 0;
    var pt = function (e) { var b = cv.getBoundingClientRect(); var t = e.touches ? e.touches[0] : e; return { x: t.clientX - b.left, y: t.clientY - b.top }; };
    var draw = function (p) { x.lineWidth = 46; x.lineCap = 'round'; x.beginPath(); if (last) { x.moveTo(last.x, last.y); x.lineTo(p.x, p.y); } else { x.arc(p.x, p.y, 23, 0, Math.PI * 2); x.fill(); } x.stroke(); last = p; };
    var cleared = function () { var data = x.getImageData(0, 0, cv.width, cv.height).data, n = 0, t = 0; for (var i = 3; i < data.length; i += 64) { t++; if (data[i] === 0) n++; } return n / t; };
    var start = function (e) { down = true; last = null; box.classList.add('is-scratching'); draw(pt(e)); e.preventDefault(); };
    var move = function (e) { if (!down) return; draw(pt(e)); e.preventDefault(); if (++moves % 6 === 0 && cleared() > .45) { down = false; reveal(); } };
    var end = function () { down = false; last = null; if (!scratched && cleared() > .3) reveal(); };
    cv.addEventListener('mousedown', start); cv.addEventListener('mousemove', move); addEventListener('mouseup', end);
    cv.addEventListener('touchstart', start, { passive: false }); cv.addEventListener('touchmove', move, { passive: false }); cv.addEventListener('touchend', end);
  }

  /* ---- open / close ---- */
  var focusables = function () { return $$('button:not([disabled]):not([hidden]), a[href], input:not([disabled])').filter(function (el) { return el.offsetParent !== null && !el.closest('.gxp-teaser'); }); };
  var open = function (why) {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { if (cur === 'scratch') initScratch(); var i = $('.gxp-step.is-on input'); (i || card).focus({ preventScroll: true }); }, 380);
    track('Viewed GLiTCH Popup', { trigger: why || 'manual', layout: mfirst ? 'phone_sms_first' : 'email_first' });
  };
  var close = function () {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (!ls.get(KEY.joined)) { ls.set(KEY.closed, String(Date.now())); if (d.teaser === 'true') root.classList.add('has-teaser'); }
    else root.classList.remove('has-teaser');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gxp-close],[data-gxp-open],[data-gxp-skip],[data-gxp-done],[data-gxp-next],[data-gxp-flavor],[data-gxp-reveal],[data-gxp-claim]');
    if (!t) return;
    if (t.hasAttribute('data-gxp-open')) { e.preventDefault(); open('teaser'); return; }
    if (t.hasAttribute('data-gxp-close')) { e.preventDefault(); close(); return; }
    if (t.hasAttribute('data-gxp-reveal')) { reveal(); return; }
    if (t.hasAttribute('data-gxp-claim')) { next(); return; }
    if (t.hasAttribute('data-gxp-skip')) { updateProfile({ favorite_flavor: 'All of them' }); next(); return; }
    if (t.hasAttribute('data-gxp-done')) { go('done'); return; }
    if (t.hasAttribute('data-gxp-next')) { next(); return; }
    if (t.hasAttribute('data-gxp-flavor')) {
      $$('[data-gxp-flavor]').forEach(function (b) { b.classList.remove('is-picked'); });
      t.classList.add('is-picked');
      var fl = t.getAttribute('data-gxp-flavor');
      updateProfile({ favorite_flavor: fl }); track('Picked Favorite Flavor', { flavor: fl });
      setTimeout(next, 320);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---- forms ---- */
  var busy = function (form, on) { var b = form.querySelector('button'); if (b) b.disabled = on; };
  var err = function (form, msg) { var p = form.parentNode.querySelector('[data-gxp-err]'); if (p) p.textContent = msg || ''; };

  var ef = $('[data-gxp-email-form]');
  if (ef) ef.addEventListener('submit', function (e) {
    e.preventDefault();
    var inp = ef.querySelector('input'); var v = (inp.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) { inp.setAttribute('aria-invalid', 'true'); err(ef, 'That email looks off. Try again?'); return; }
    inp.removeAttribute('aria-invalid'); err(ef, ''); busy(ef, true);
    who.email = v;
    var a = { email: v, properties: { signup_source: 'first_dibs_popup', signup_page: path, popup_layout: mfirst ? 'phone_sms_first' : 'email_first' } };
    if (who.phone) a.phone_number = who.phone;
    subscribe(a, d.emailList || CFG.list, 'email')
      .then(function () { markJoined(); ls.set(KEY.email, '1'); track('Joined Presale Waitlist', { source: 'popup' }); next(); })
      .catch(function (x) { who.email = ''; err(ef, x && x.field === 'email' ? 'That email looks off. Try again?' : 'Something glitched. Try again in a sec.'); })
      .then(function () { busy(ef, false); });
  });

  var sf = $('[data-gxp-sms-form]');
  if (sf) sf.addEventListener('submit', function (e) {
    e.preventDefault();
    var inp = sf.querySelector('input'); var digits = (inp.value || '').replace(/\D/g, '');
    if (digits.length === 10) digits = '1' + digits;
    if (digits.length !== 11 || digits[0] !== '1') { inp.setAttribute('aria-invalid', 'true'); err(sf, 'Enter a 10-digit US mobile number.'); return; }
    inp.removeAttribute('aria-invalid'); err(sf, ''); busy(sf, true);
    who.phone = '+' + digits;
    var a = { phone_number: who.phone, properties: { sms_source: 'first_dibs_popup', signup_page: path } };
    if (who.email) a.email = who.email;
    subscribe(a, d.smsList, 'sms')
      .then(function () { markJoined(); ls.set(KEY.sms, '1'); track('Joined SMS Early Access', { source: 'popup' }); next(); })
      .catch(function (x) { who.phone = ''; err(sf, x && x.field === 'phone_number' ? "That number can't get texts. Double-check it?" : 'Something glitched. Try again in a sec.'); })
      .then(function () { busy(sf, false); });
  });
  /* format phone as they type */
  var ph = $('#gxp-phone');
  if (ph) ph.addEventListener('input', function () {
    var v = ph.value.replace(/\D/g, '').replace(/^1/, '').slice(0, 10);
    ph.value = v.length > 6 ? '(' + v.slice(0, 3) + ') ' + v.slice(3, 6) + '-' + v.slice(6) : v.length > 3 ? '(' + v.slice(0, 3) + ') ' + v.slice(3) : v;
  });

  /* ---- triggers ---- */
  if (design) { root.classList.add('has-teaser'); return; }
  if (joined || blockedPath) return;
  if (cooling) { if (d.teaser === 'true') root.classList.add('has-teaser'); return; }

  var fired = false, consentDone = false;
  document.addEventListener('visitorConsentCollected', function () { consentDone = true; });
  var delay = Math.max(5, parseInt(d.delay || '12', 10)) * 1000;
  var pct = parseInt(d.scroll || '40', 10) / 100;
  var timer, onScroll, onExit;
  var cleanup = function () { clearTimeout(timer); removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onExit); };
  var fire = function (why) {
    if (fired) return;
    if (document.querySelector('.cart-drawer.open,[data-cart-drawer].open,.is-cart-open')) { timer = setTimeout(function () { fire(why); }, 8000); return; }
    /* let the cookie banner go first: never stack two overlays */
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!consentDone && cp && cp.shouldShowBanner && cp.shouldShowBanner() && !(cp.currentVisitorConsent && cp.currentVisitorConsent().marketing)) { timer = setTimeout(function () { fire(why); }, 3000); return; }
    fired = true; cleanup(); open(why);
  };
  timer = setTimeout(function () { fire('time'); }, delay);
  onScroll = function () { var h = document.documentElement.scrollHeight - innerHeight; if (h > 400 && scrollY / h >= pct && performance.now() > 5000) fire('scroll'); };
  onExit = function (e) { if (!e.relatedTarget && e.clientY <= 4) fire('exit'); };
  addEventListener('scroll', onScroll, { passive: true });
  if (d.exit === 'true' && matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', onExit);
  /* someone adding to cart is buying: don't interrupt them this visit */
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-atc],.sbx-atc,[name="add"],[data-quick-add]')) { cleanup(); fired = true; } }, true);
})();
